import { cx } from 'cva';
import React from 'react';
import { styled } from '@mui/material/styles';

// const StyledFollowButton = ({ isFollowing, disabled, width, children }) => {
//   return (
//     <button
//       className={cx(
//         'cursor-default rounded-full border border-solid px-1.5 py-0.5 text-14 font-semibold',
//         isFollowing
//           ? 'before:content["Following"]'
//           : 'before:content["Follow"]',
//         disabled
//           ? 'border-text-disabled text-text-disabled'
//           : 'pointer text-primary hover:border-primary hover:bg-primary hover:text-white',
//         isFollowing && !disabled && 'hover:before:content["Unfollow"]',
//       )}>
//       {children}
//     </button>
//   );
// };


// const StyledFollowButton = styled('button', {
//   shouldForwardProp: (prop) =>
//     !['disabled', 'isFollowing', 'width'].includes(prop),
// })(({ theme, isFollowing, disabled, width }) => ({
//   color: disabled ? '#757E81' : 'rgb(51, 204, 204)',
//   border: '1px solid',
//   // borderColor: theme.palette.gray.border,
//   borderRadius: 28,
//   padding: theme.spacing(0.5, 1.5),
//   fontSize: '.9rem',
//   fontWeight: 700,
//   ...(width && { width }),
//   cursor: 'default',
//   '&:before': {
//     content: isFollowing ? '"Following"' : '"Follow"',
//   },

//   '&:hover': !disabled && {
//     cursor: 'pointer',
//     color: '#ffffff',
//     backgroundColor: 'rgb(51, 204, 204)',
//     borderColor: 'rgb(51, 204, 204)',
//     '&:before': isFollowing && {
//       content: '"Unfollow"',
//     },
//   },
// }));

const StyledFollowButton = styled('button', {
  shouldForwardProp: (prop) =>
    !['disabled', 'isFollowing', 'width'].includes(prop),
})(({ theme, isFollowing, disabled, width }) => ({
  color: disabled ? '#757E81' : 'rgb(51, 204, 204)',
  border: '1px solid',
  // borderColor: theme.palette.gray.border,
  borderRadius: 28,
  padding: theme.spacing(0.5, 1.5),
  fontSize: '16px',
  fontWeight: 400,
  backgroundColor: 'rgb(51, 204, 204)',
  ...(width && { width }),
  cursor: 'default',
  '&:before': {
    content: isFollowing ? '"Following"' : '"Follow"',
  },

  '&:hover': !disabled && {
    cursor: 'pointer',
    color: 'rgb(51, 204, 204)',
    // backgroundColor: 'rgb(51, 204, 204)',
    // borderColor: 'rgb(51, 204, 204)',
    backgroundColor: '#fff',
    '&:before': isFollowing && {
      content: '"Unfollow"',
    },
  },
}));

// const StyledFollowButton = styled('button', {
//   shouldForwardProp: (prop) =>
//     !['disabled', 'isFollowing', 'width'].includes(prop),
// })(({ theme, isFollowing, disabled, width }) => ({
//   color: disabled ? '#757E81' : 'rgb(51, 204, 204)',
//   border: '2px solid',
//   // borderColor: theme.palette.gray.border,
//   borderRadius: 28,
//   padding: theme.spacing(0.5, 1.5),
//   fontSize: '16px',
//   fontWeight: 400,
//   backgroundColor: 'rgb(51, 204, 204)',
//   ...(width && { width }),
//   cursor: 'default',
//   '&:before': {
//     content: isFollowing ? '"Following"' : '"Follow"',
//   },

//   '&:hover': !disabled && {
//     cursor: 'pointer',
//     color: 'rgb(51, 204, 204)',
//     // backgroundColor: 'rgb(51, 204, 204)',
//     // borderColor: 'rgb(51, 204, 204)',
//     backgroundColor: '#fff',
//     '&:before': isFollowing && {
//       content: '"Unfollow"',
//     },
//   },
// }));

export default StyledFollowButton;
